import { COLORS } from 'app/constants'
import { goTo } from 'app/hooks/navigation'
import { useLogQueue } from 'app/hooks/trade/logQueue'
import { useTradePosition } from 'app/hooks/trade/tradePosition'
import { useUserSocket } from 'app/hooks/trade/userSocket'
import MTradeModal from 'app/pages/MTradeModal'
import React, { lazy, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { MText } from 'styles/mobilePageStyles'
import { ThemeContext } from 'theme/ThemeProvider'
import { CToast } from '../../components/Common'
import { COINHIDE, COIN_URL } from '../../constants/APIKEYS'
import { useToken } from '../../hooks'
import { useExchangeStore } from '../../hooks/trade/exchangeStore'
import { OrdersPage } from '../../pages/OrdersPage/Loadable'
import { BottomTabContainer, BottomTabSection, ButtonTabItems, TabIcon, TabLabel } from './styles'
import { useTradeStore } from 'app/hooks/trade/tradeStore'

const HomeMobile = lazy(() => import("app/pages/HomePage/HomeMobile"));
const TradeMobile = lazy(() => import("app/pages/TradePage/TradeMobile"));
const AssetMobile = lazy(() => import("app/pages/AssetPage/AssetMobile"));
const OrdersMobile = lazy(() => import("../../pages/OrdersPage/OrdersMobile"));

const BottomTabs = () => {
	const { textsilver } = useContext(ThemeContext).theme.COLORS
	const { isDarkMode } = useContext(ThemeContext)
	const location = useLocation()
	const navigation = useHistory()
	const { data: token } = useToken()
	const { saveLog } = useLogQueue()


	let pathname = '홈'
	if (location.pathname === '/') {
		pathname = '홈'
	} else if (location.pathname.includes('trade')) {
		pathname = '거래'
	} else if (location.pathname.includes('assets')) {
		pathname = '입출금'
	} else if (location.pathname.includes('orders')) {
		pathname = '체결/손익'
	} else if (location.pathname.includes('login')) {
		if (token) {
			pathname = '홈'
		} else {
			pathname = 'login'
		}
	} else if (location.pathname.includes('signup')) {
		pathname = 'signup'
	} else if (location.pathname.includes('settings')) {
		pathname = 'settings'
	}

	const { ep_id} = useTradeStore()
 
	const { EPs } = useExchangeStore()

	const [tab, setTab] = useState(pathname)
	const tabUrls = {
		home: '/',
		trade: '/trade/' + (ep_id || EPs?.[0]?.id),
		assets: '/assets',
		홈: '/',
		거래: '/trade/' + (ep_id || EPs?.[0]?.id ),
		입출금: '/assets',
		"체결/손익": "/orders",
		orders: '/orders',
		signup: '/signup',
		login: '/login',
	}

	useEffect(() => {
		setTab(pathname)


	}, [pathname])

	const tabs = [
		{
			title: '홈',
			icon: '🏠',
		},
	]

	if (COINHIDE) {
		tabs.pop()
	}
	const tabComponents = {
		홈: <HomeMobile />,
	}


	return (
		<BottomTabContainer className="mobile">
			{tabComponents[tab]}
			<BottomTabSection isDarkMode={isDarkMode}>
				{tabs.map((item, index) => {
					const isActive = tab === item.title
					return (
						<ButtonTabItems
							key={index.toString()}
							isActive={isActive}
							type="button"
							onClick={() => {
								if (item?.title === '코인선물') {
									window.location.href =
										COIN_URL +
										'?ssotoken=' +
										token +
										'&darkmode=' +
										(isDarkMode ? 'dark' : 'light')
									return
								}
								setTab(item?.title)

								saveLog({
									log: 'FR008',
									data: item?.title,
								}, 'MTS')

								goTo(navigation, tabUrls[item?.title])
							}}>
							<TabIcon isActive={isActive}>
								{item?.icon}
							</TabIcon>
							<TabLabel isActive={isActive}>
								{item?.title}
							</TabLabel>
						</ButtonTabItems>
					)
				})}
			</BottomTabSection>
			<MTradeModal />
			<CToast />
		</BottomTabContainer>
	)
}

export default React.memo(BottomTabs)
